import Vue from 'vue'
import { createTablePopover } from './component'
import Popper from 'element-ui/src/utils/popper.js'

export function CreatePopupManager () {
  const TablePopover = createTablePopover()

  const TablePopoverConstructor = Vue.extend(TablePopover)

  const PopupManager = {}

  function getPopperModalInstance (options) {
    const modalInstance = PopupManager.modalInstance
    if (!modalInstance) {
      const modalDom = document.createElement('div')
      let instance
      instance = new TablePopoverConstructor({
        el: modalDom
      })
      // 属性合并
      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          instance[prop] = options[prop]
        }
      }
      document.body.appendChild(instance.$el)
      PopupManager.modalInstance = instance
    }
    return PopupManager.modalInstance
  }
  function getPoppperJsInstance () {
    return PopupManager.virtualTablePopperJs
  }

  function createPopperJsInstance (reference, popper, options) {
    PopupManager.virtualTablePopperJs = new Popper(reference, popper, options)
  }
  function removePopperModalInstance () {
    const modalInstance = PopupManager.modalInstance
    if (modalInstance) {
      modalInstance.$el && document.body.removeChild(modalInstance.$el)
      PopupManager.modalInstance = undefined
      PopupManager.virtualTablePopperJs = undefined
    }
  }

  return {
    getPopperModalInstance,
    createPopperJsInstance,
    removePopperModalInstance,
    getPoppperJsInstance
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-edit-table/popover/popup-manager.js